import React, { createContext, useContext } from "react";

import type {
  OrderDetailV2ActionModalConfig,
  OrderDetailV2ContextValue,
} from "./types";

const OrderDetailV2Context = createContext<OrderDetailV2ContextValue | null>(
  null
);

export const OrderDetailV2Provider = ({
  value,
  children,
}: {
  value: OrderDetailV2ContextValue;
  children: React.ReactNode;
}) => (
  <OrderDetailV2Context.Provider value={value}>
    {children}
  </OrderDetailV2Context.Provider>
);

export const useOrderDetailV2 = (): OrderDetailV2ContextValue => {
  const ctx = useContext(OrderDetailV2Context);
  if (!ctx) {
    throw new Error(
      "useOrderDetailV2 must be used within OrderDetailV2Provider"
    );
  }
  return ctx;
};

// Re-export types for backward compatibility
export type { OrderDetailV2ActionModalConfig, OrderDetailV2ContextValue };
